import { IGetCardLogo } from '../../interfaces';
import ECardType from '../../interfaces/ECardType';
import cardLogos from './cardLogos';

const getCardLogo = ({ cardType }: IGetCardLogo): string | undefined =>
  cardType && cardLogos[cardType.toLowerCase() as keyof typeof ECardType];

export default getCardLogo;
